import React from 'react';
import Icon from '../../../components/AppIcon';

const CategoryFilter = ({ categories, activeCategory, onCategoryChange }) => {
  return (
    <section className="sticky top-16 z-40 bg-background/95 backdrop-blur-sm border-b border-border py-4 md:py-6">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="flex items-center gap-3 md:gap-4 overflow-x-auto pb-2 scrollbar-hide">
          {categories?.map((category) => (
            <button
              key={category?.id}
              onClick={() => onCategoryChange(category?.id)}
              className={`flex-shrink-0 flex items-center gap-2 px-4 md:px-6 py-2 md:py-3 rounded-full font-semibold text-sm md:text-base transition-all duration-300 whitespace-nowrap ${
                activeCategory === category?.id
                  ? 'bg-primary text-primary-foreground shadow-lg scale-105'
                  : 'bg-muted text-muted-foreground hover:bg-muted/80'
              }`}
            >
              <Icon 
                name={category?.icon} 
                size={18} 
                color={activeCategory === category?.id ? 'var(--color-primary-foreground)' : 'var(--color-muted-foreground)'} 
              />
              <span>{category?.name}</span>
              <span className={`text-xs px-2 py-0.5 rounded-full ${
                activeCategory === category?.id 
                  ? 'bg-primary-foreground/20' 
                  : 'bg-background'
              }`}>
                {category?.count}
              </span>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CategoryFilter;